import { useContext } from "react"
import { LastMatchContext } from "./LastMatchProvider"

export const useLastMatch = () => useContext(LastMatchContext)
